import pre_invoice_operations_en from '@modules/Invoices/shared/i18n/en/preInvoiceOperations.json';
import pre_invoice_operations_es from '@modules/Invoices/shared/i18n/es/preInvoiceOperations.json';
import productivityEn from '@modules/Productivity/i18n/en/productivity.json';
import productivityEs from '@modules/Productivity/i18n/es/productivity.json';
// Importar traducciones de UI compartidos
import ui_en from '@shared/i18n/ui/en/ui.json';
import ui_es from '@shared/i18n/ui/es/ui.json';
import operator_module_en from '@shared/i18n/operator/en/operatorModule.json';
import operator_module_es from '@shared/i18n/operator/es/operatorModule.json';

// Importar traducciones del nuevo m?dulo de Locations
import locations_module_en from '@modules/Locations/i18n/en/locations.json';
import locations_module_es from '@modules/Locations/i18n/es/locations.json';
import merchandise_blocks_module_en from '@modules/MerchandiseBlocks/i18n/en/merchandise-blocks.json';
import merchandise_blocks_module_es from '@modules/MerchandiseBlocks/i18n/es/merchandise-blocks.json';
import stock_transfers_module_en from '@modules/StockTransfers/i18n/en/stockTransfers.json';
import stock_transfers_module_es from '@modules/StockTransfers/i18n/es/stockTransfers.json';

// Importar traducciones del nuevo m?dulo de Carts
import carts_module_en from '@modules/Carts/i18n/en/carts.json';
import carts_module_es from '@modules/Carts/i18n/es/carts.json';

// Importar traducciones del nuevo m?dulo de StockMovements
import stockmovements_module_en from '@modules/Reports/StockMovements/i18n/en/stockmovements.json';
import stockmovements_module_es from '@modules/Reports/StockMovements/i18n/es/stockmovements.json';

// Importar traducciones del nuevo m?dulo de StockLocations
import locationmovements_module_en from '@modules/Reports/LocationMovements/i18n/en/location-movements.json';
import locationmovements_module_es from '@modules/Reports/LocationMovements/i18n/es/location-movements.json';

// Importar traducciones del nuevo m?dulo de Printers
import printers_module_en from '@modules/configuration/Printers/i18n/en/printers.json';
import printers_module_es from '@modules/configuration/Printers/i18n/es/printers.json';

// Importar traducciones del m?dulo de Packs
import packs_module_en from '@modules/Packs/i18n/en/packs.json';
import packs_module_es from '@modules/Packs/i18n/es/packs.json';

// Importar traducciones del m?dulo de Packaging
import packaging_module_en from '@modules/Packaging/packaging/i18n/en/packaging.json';
import packaging_module_es from '@modules/Packaging/packaging/i18n/es/packaging.json';
import warehouse_stock_module_en from '@modules/Packaging/packaging/i18n/en/warehouse-stock.json';
import warehouse_stock_module_es from '@modules/Packaging/packaging/i18n/es/warehouse-stock.json';
import packaging_recipes_en from '@modules/Packaging/packagingRecipes/i18n/en/packaging-recipes.json';
import packaging_recipes_es from '@modules/Packaging/packagingRecipes/i18n/es/packaging-recipes.json';
import product_containers_en from '@modules/Packaging/productContainers/i18n/en/product-containers.json';
import product_containers_es from '@modules/Packaging/productContainers/i18n/es/product-containers.json';

// Importar traducciones del m?dulo de Shops
import shops_module_en from '@modules/Shops/List/i18n/en/shops.json';
import shops_module_es from '@modules/Shops/List/i18n/es/shops.json';

// Importar traducciones del componente de navegaci?n
import navigationEn from '@shared/components/navigation/i18n/navigationEn';
import navigationEs from '@shared/components/navigation/i18n/navigationEs';

// Traducciones legacy de locations (si existen)
/*import pending_products_en from '@/features/pending-products/i18n/en/pending-products.json';
import pending_products_es from '@/features/pending-products/i18n/es/pending-products.json';
import printers_en from '@/features/printers/i18n/en/printers.json';
import printers_es from '@/features/printers/i18n/es/printers.json';
import stock_movements_en from '@/features/stock-movements/i18n/en/stock-movements.json';
import stock_movements_es from '@/features/stock-movements/i18n/es/stock-movements.json';
import bulk_actions_toolbar_en from '@deprecated-shared/ui/components/warehouse/bulk-actions-toolbar/i18n/en/bulk-actions-toolbar.json';
import bulk_actions_toolbar_es from '@deprecated-shared/ui/components/warehouse/bulk-actions-toolbar/i18n/es/bulk-actions-toolbar.json';*/
import general_en from '@modules/configuration/General/i18n/en/general.json';
import general_es from '@modules/configuration/General/i18n/es/general.json';
import integrated_messaging_en from '@modules/configuration/IntegratedMessaging/i18n/en/integrated-messaging.json';
import integrated_messaging_es from '@modules/configuration/IntegratedMessaging/i18n/es/integrated-messaging.json';
import profile_en from '@modules/configuration/Profile/i18n/en/profile.json';
import profile_es from '@modules/configuration/Profile/i18n/es/profile.json';
import roles_en from '@modules/configuration/Roles/i18n/en/roles.json';
import roles_es from '@modules/configuration/Roles/i18n/es/roles.json';
import rules_en from '@modules/configuration/Rules/i18n/en/rules.json';
import rules_es from '@modules/configuration/Rules/i18n/es/rules.json';
import shipping_rule_presets_en from '@modules/configuration/ShippingRulePresets/i18n/en/shippingRulePresetsModule.json';
import shipping_rule_presets_es from '@modules/configuration/ShippingRulePresets/i18n/es/shippingRulePresetsModule.json';
import preparation_calendar_en from '@modules/configuration/PreparationCalendar/Manage/i18n/en/preparationCalendar.json';
import preparation_calendar_es from '@modules/configuration/PreparationCalendar/Manage/i18n/es/preparationCalendar.json';
import merchandise_en from '@modules/Merchandise/i18n/en/merchandise.json';
import merchandise_es from '@modules/Merchandise/i18n/es/merchandise.json';

// Importar traducciones del m?dulo de Suscription
import suscription_module_en from '@modules/configuration/Suscription/i18n/en/suscription.json';
import suscription_module_es from '@modules/configuration/Suscription/i18n/es/suscription.json';

// Importar traducciones del m?dulo de Afiliados
import affiliates_en from '@modules/configuration/Affiliates/i18n/en/affiliates.json';
import affiliates_es from '@modules/configuration/Affiliates/i18n/es/affiliates.json';

// Importar traducciones del m?dulo Auth
import { authEn, authEs } from '@modules/Auth/i18n';

import eligible_storage_en from '@modules/Invoices/EligibleStorage/i18n/en/eligibleStorage.json';
import eligible_storage_es from '@modules/Invoices/EligibleStorage/i18n/es/eligibleStorage.json';
import eligible_extra_work_en from '@modules/Invoices/EligibleExtraWork/i18n/en/eligibleExtraWork.json';
import eligible_extra_work_es from '@modules/Invoices/EligibleExtraWork/i18n/es/eligibleExtraWork.json';
import wholesale_billing_en from '@modules/Invoices/EligibleWholesalePreparation/i18n/en/wholesaleBilling.json';
import wholesale_billing_es from '@modules/Invoices/EligibleWholesalePreparation/i18n/es/wholesaleBilling.json';
import eligible_crm_management_en from '@modules/Invoices/EligibleCrmManagement/i18n/en/eligibleCrmManagement.json';
import eligible_crm_management_es from '@modules/Invoices/EligibleCrmManagement/i18n/es/eligibleCrmManagement.json';
import shipment_credits_en from '@modules/Invoices/ShipmentCredits/i18n/en/shipmentCredits.json';
import shipment_credits_es from '@modules/Invoices/ShipmentCredits/i18n/es/shipmentCredits.json';
import invoices_module_en from '@modules/Invoices/Invoices/List/i18n/en/invoices.json';
import invoices_module_es from '@modules/Invoices/Invoices/List/i18n/es/invoices.json';
import invoices_view_module_en from '@modules/Invoices/Invoices/View/i18n/en/invoicesView.json';
import invoices_view_module_es from '@modules/Invoices/Invoices/View/i18n/es/invoicesView.json';
import invoices_orders_en from '@modules/Invoices/InvoicesOrders/List/i18n/en/invoicesOrders.json';
import invoices_orders_es from '@modules/Invoices/InvoicesOrders/List/i18n/es/invoicesOrders.json';
import minimum_fees_en from '@modules/Invoices/MinimumFees/i18n/en/minimumFees.json';
import minimum_fees_es from '@modules/Invoices/MinimumFees/i18n/es/minimumFees.json';
import pre_invoices_en from '@modules/Invoices/PreInvoices/List/i18n/en/preInvoices.json';
import pre_invoices_es from '@modules/Invoices/PreInvoices/List/i18n/es/preInvoices.json';
import view_pre_invoices_en from '@modules/Invoices/PreInvoices/View/i18n/en/viewPreInvoices.json';
import view_pre_invoices_es from '@modules/Invoices/PreInvoices/View/i18n/es/viewPreInvoices.json';
import createEditOrders_en from '@modules/Orders/CreateEditOrders/i18n/en/createEditOrders.json';
import createEditOrders_es from '@modules/Orders/CreateEditOrders/i18n/es/createEditOrders.json';
import orders_en from '@modules/Orders/List/i18n/en/orders.json';
import orders_es from '@modules/Orders/List/i18n/es/orders.json';
// Eliminado OrdersAgGrid: ahora Orders es el m?dulo vigente
import viewOrders_en from '@modules/Orders/ViewOrders/i18n/en/viewOrdersModule.json';
import viewOrders_es from '@modules/Orders/ViewOrders/i18n/es/viewOrdersModule.json';
import ordersShipped_en from '@modules/OrdersShipped/i18n/en/ordersShipped.json';
import {
  shipmentStatusTransitionsEn,
  shipmentStatusTransitionsEs,
} from '@modules/Orders/ShipmentStatusTransitions/i18n';
import ordersShipped_es from '@modules/OrdersShipped/i18n/es/ordersShipped.json';
import create_edit_products_en from '@modules/Products/CreateEdit/i18n/en/create-edit-products.json';
import create_edit_products_es from '@modules/Products/CreateEdit/i18n/es/create-edit-products.json';
import products_en from '@modules/Products/List/i18n/en/products.json';
import products_es from '@modules/Products/List/i18n/es/products.json';

// Importar traducciones del módulo Unreferenced Entries
import unreferenced_entries_en from '@modules/UnreferencedEntries/List/i18n/en/unreferencedEntries.json';
import unreferenced_entries_es from '@modules/UnreferencedEntries/List/i18n/es/unreferencedEntries.json';

// Importar traducciones del m?dulo CRM
import crm_module_en from '@modules/CRM/List/i18n/en/crm.json';
import crm_module_es from '@modules/CRM/List/i18n/es/crm.json';
import management_hours_en from '@modules/CRM/ManagementHours/i18n/en/managementHours.json';
import management_hours_es from '@modules/CRM/ManagementHours/i18n/es/managementHours.json';

// Importar traducciones del m?dulo de Wallets
import wallets_module_en from '@modules/Wallets/List/i18n/en/wallets.json';
import wallets_module_es from '@modules/Wallets/List/i18n/es/wallets.json';
import wallet_module_detail_en from '@modules/Wallets/Wallet/i18n/en/wallet.json';
import wallet_module_detail_es from '@modules/Wallets/Wallet/i18n/es/wallet.json';

// Importar traducciones del m?dulo de BankAccounts
import bank_accounts_module_en from '@modules/Wallets/BankAccounts/i18n/en/bankAccounts.json';
import bank_accounts_module_es from '@modules/Wallets/BankAccounts/i18n/es/bankAccounts.json';

// Importar traducciones del m?dulo de Withdrawals
import withdrawals_module_en from '@modules/Wallets/Withdrawals/i18n/en/withdrawals.json';
import withdrawals_module_es from '@modules/Wallets/Withdrawals/i18n/es/withdrawals.json';
import {
  withdrawalPaymentFilesModuleEn,
  withdrawalPaymentFilesModuleEs,
} from '@modules/Wallets/WithdrawalPaymentFiles/i18n';

// Importar traducciones del m?dulo de Topups
import { topupsEn, topupsEs } from '@modules/Wallets/Topups/i18n';
import { accountingSyncEn, accountingSyncEs } from '@modules/Wallets/AccountingSync/i18n';

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value);

const mergeDeep = (target: Record<string, unknown>, source: Record<string, unknown>): Record<string, unknown> => {
  const output: Record<string, unknown> = { ...target };

  Object.entries(source).forEach(([key, value]) => {
    if (isPlainObject(value) && isPlainObject(output[key])) {
      output[key] = mergeDeep(output[key] as Record<string, unknown>, value);
    } else if (isPlainObject(value)) {
      output[key] = mergeDeep({}, value);
    } else {
      output[key] = value;
    }
  });

  return output;
};

const mergeTranslations = (...translations: Record<string, unknown>[]): Record<string, unknown> =>
  translations.reduce<Record<string, unknown>>((acc, current) => mergeDeep(acc, current), {});

const walletsModuleEn = mergeTranslations(wallet_module_detail_en, wallets_module_en) as typeof wallets_module_en;
const walletsModuleEs = mergeTranslations(wallet_module_detail_es, wallets_module_es) as typeof wallets_module_es;

// Importar traducciones del m?dulo OrderPreparation
import orderpreparation_en from '@modules/OrderPreparation/List/i18n/en/orderpreparation.json';
import orderpreparation_es from '@modules/OrderPreparation/List/i18n/es/orderpreparation.json';

import relocations_en from '@modules/Relocations/List/i18n/en/relocations.json';
import relocations_es from '@modules/Relocations/List/i18n/es/relocations.json';
import relocation_process_en from '@modules/Relocations/Process/i18n/en/relocationProcess.json';
import relocation_process_es from '@modules/Relocations/Process/i18n/es/relocationProcess.json';

// Importar traducciones del m?dulo Manifests
import manifests_en from '@modules/OrderPreparation/Manifests/i18n/en/manifests.json';
import manifests_es from '@modules/OrderPreparation/Manifests/i18n/es/manifests.json';

// Importar traducciones del m?dulo LocationOrders
import locationordersDetail_en from '@modules/LocationOrders/Detail/i18n/en/detail.json';
import locationordersDetail_es from '@modules/LocationOrders/Detail/i18n/es/detail.json';
import locationorders_en from '@modules/LocationOrders/List/i18n/en/locationorders.json';
import locationorders_es from '@modules/LocationOrders/List/i18n/es/locationorders.json';

// Importar traducciones del m?dulo Picking
import picking_en from '@modules/OrderPreparation/Picking/i18n/en/picking.json';
import picking_es from '@modules/OrderPreparation/Picking/i18n/es/picking.json';

// Importar traducciones del m?dulo MassivePacking
import massive_packing_en from '@modules/OrderPreparation/MassivePacking/i18n/en/massive-packing.json';
import massive_packing_es from '@modules/OrderPreparation/MassivePacking/i18n/es/massive-packing.json';

// Importar traducciones del módulo Packing
import packing_en from '@modules/OrderPreparation/PackingV2/i18n/en/packing.json';
import packing_es from '@modules/OrderPreparation/PackingV2/i18n/es/packing.json';

// Importar traducciones del módulo PackingByCart
import packing_by_cart_en from '@modules/OrderPreparation/PackingByCart/i18n/en/packingByCart.json';
import packing_by_cart_es from '@modules/OrderPreparation/PackingByCart/i18n/es/packingByCart.json';

import orders_held_for_preparation_en from '@modules/OrdersHeldForPreparation/Manage/i18n/en/ordersHeldForPreparation.json';
import orders_held_for_preparation_es from '@modules/OrdersHeldForPreparation/Manage/i18n/es/ordersHeldForPreparation.json';

import pending_orders_en from '@modules/PendingOrders/i18n/en/pendingOrders.json';
import pending_orders_es from '@modules/PendingOrders/i18n/es/pendingOrders.json';

// Importar traducciones del m?dulo Home
import home_module_en from '@modules/Home/i18n/en/homeModule.json';
import home_module_es from '@modules/Home/i18n/es/homeModule.json';

// Importar traducciones del m?dulo Returned
import returned_module_en from '@modules/Returned/List/i18n/en/returned.json';
import returned_module_es from '@modules/Returned/List/i18n/es/returned.json';

// Importar traducciones del m?dulo Receive
import receive_module_en from '@modules/Returned/Receive/i18n/en/receive.json';
import receive_module_es from '@modules/Returned/Receive/i18n/es/receive.json';

// Importar traducciones del m?dulo Reused (legacy)
import reused_module_en from '@modules/Reused/i18n/en/reused.json';
import reused_module_es from '@modules/Reused/i18n/es/reused.json';
import refund_receptions_module_en from '@modules/RefundReceptions/i18n/en/refundReceptions.json';
import refund_receptions_module_es from '@modules/RefundReceptions/i18n/es/refundReceptions.json';

// Importar traducciones del m?dulo ProductsWithoutStock
import inventory_module_en from '@modules/Reports/Inventory/i18n/en/inventory.json';
import inventory_module_es from '@modules/Reports/Inventory/i18n/es/inventory.json';
import products_without_stock_module_en from '@modules/Reports/ProductsWithoutStock/i18n/en/productsWithoutStock.json';
import products_without_stock_module_es from '@modules/Reports/ProductsWithoutStock/i18n/es/productsWithoutStock.json';

// Importar traducciones del m?dulo Clients
import create_edit_clients_en from '@modules/Clients/CreateEdit/i18n/en/createEditClients.json';
import create_edit_clients_es from '@modules/Clients/CreateEdit/i18n/es/createEditClients.json';
import clients_module_en from '@modules/Clients/List/i18n/en/clients.json';
import clients_module_es from '@modules/Clients/List/i18n/es/clients.json';
import view_client_en from '@modules/Clients/ViewClient/i18n/en/viewClient.json';
import view_client_es from '@modules/Clients/ViewClient/i18n/es/viewClient.json';

// Importar traducciones del m?dulo CoverageZones
import coverage_zones_en from '@modules/configuration/CoverageZones/i18n/en/coverageZones.json';
import coverage_zones_es from '@modules/configuration/CoverageZones/i18n/es/coverageZones.json';

// Importar traducciones del m?dulo ShipmentStatusMapping
import shipment_status_mapping_en from '@modules/configuration/ShipmentStatusMapping/i18n/en/shipment-status-mapping.json';
import shipment_status_mapping_es from '@modules/configuration/ShipmentStatusMapping/i18n/es/shipment-status-mapping.json';

// Importar traducciones del módulo COD Payments
import { codCourierFilesEn, codCourierFilesEs } from '@modules/CODPayments/CourierFiles/List/i18n';
import { codCourierFileDetailEn, codCourierFileDetailEs } from '@modules/CODPayments/CourierFiles/View/i18n';
import { codMismatchesEn, codMismatchesEs } from '@modules/CODPayments/Mismatches/List/i18n';
import { codReviewsEn, codReviewsEs } from '@modules/CODPayments/Reviews/List/i18n';
import cod_payout_items_en from '@modules/CODPayments/PayoutItems/List/i18n/en/payout-items.json';
import cod_payout_items_es from '@modules/CODPayments/PayoutItems/List/i18n/es/payout-items.json';
import cod_payouts_en from '@modules/CODPayments/Payouts/List/i18n/en/payouts.json';
import cod_payouts_es from '@modules/CODPayments/Payouts/List/i18n/es/payouts.json';
import cod_payout_detail_en from '@modules/CODPayments/Payouts/View/i18n/en/payout-detail.json';
import cod_payout_detail_es from '@modules/CODPayments/Payouts/View/i18n/es/payout-detail.json';

// Importar traducciones del m?dulo Logistics
import logistics_module_en from '@modules/Reports/Logistics/i18n/en/logistics.json';
import logistics_module_es from '@modules/Reports/Logistics/i18n/es/logistics.json';
import logistic_pivot_module_en from '@modules/Reports/LogisticPivot/i18n/en/logisticPivot.json';
import logistic_pivot_module_es from '@modules/Reports/LogisticPivot/i18n/es/logisticPivot.json';
import profitability_module_en from '@modules/Reports/Profitability/i18n/en/profitability.json';
import profitability_module_es from '@modules/Reports/Profitability/i18n/es/profitability.json';
import tracking_module_en from '@modules/Reports/Tracking/i18n/en/tracking.json';
import tracking_module_es from '@modules/Reports/Tracking/i18n/es/tracking.json';

// Importar traducciones del m?dulo Marketing
import marketing_module_en from '@modules/Reports/Marketing/i18n/en/marketing.json';
import marketing_module_es from '@modules/Reports/Marketing/i18n/es/marketing.json';

// Importar traducciones del m?dulo OrdersWithoutWeight
import ordersWithoutWeight_module_en from '@modules/Reports/OrdersWithoutWeight/i18n/en/ordersWithoutWeight.json';
import ordersWithoutWeight_module_es from '@modules/Reports/OrdersWithoutWeight/i18n/es/ordersWithoutWeight.json';
import readyToPrepareByHour_module_en from '@modules/Reports/ReadyToPrepareByHour/i18n/en/readyToPrepareByHour.json';
import readyToPrepareByHour_module_es from '@modules/Reports/ReadyToPrepareByHour/i18n/es/readyToPrepareByHour.json';
import threePlExcelReports_module_en from '@modules/Reports/ThreePlExcelReports/i18n/en/threePlExcelReports.json';
import threePlExcelReports_module_es from '@modules/Reports/ThreePlExcelReports/i18n/es/threePlExcelReports.json';
import warehouseExcelReports_module_en from '@modules/Reports/WarehouseExcelReports/i18n/en/warehouseExcelReports.json';
import warehouseExcelReports_module_es from '@modules/Reports/WarehouseExcelReports/i18n/es/warehouseExcelReports.json';
import legacyDashboard_module_en from '@modules/Reports/LegacyDashboard/i18n/en/legacyDashboard.json';
import legacyDashboard_module_es from '@modules/Reports/LegacyDashboard/i18n/es/legacyDashboard.json';
import clientActivity_module_en from '@modules/Reports/ClientActivity/i18n/en/clientActivity.json';
import clientActivity_module_es from '@modules/Reports/ClientActivity/i18n/es/clientActivity.json';
import dataLoad_module_en from '@modules/Accounting/DataLoad/i18n/en/dataLoad.json';
import dataLoad_module_es from '@modules/Accounting/DataLoad/i18n/es/dataLoad.json';

// Importar traducciones del m?dulo Users
import users_module_en from '@modules/configuration/Users/i18n/en/usersModule.json';
import users_module_es from '@modules/configuration/Users/i18n/es/usersModule.json';

// Importar traducciones del m?dulo Popups
import popups_en from '@modules/Popups/i18n/en/popups.json';
import popups_es from '@modules/Popups/i18n/es/popups.json';

// Importar traducciones del m?dulo Notifications
import notifications_en from '@modules/Notifications/i18n/en.json';
import notifications_es from '@modules/Notifications/i18n/es.json';

// Importar traducciones del m?dulo Receptions
import receptions_module_en from '@modules/Receptions/i18n/en/receptions.json';
import receptions_module_es from '@modules/Receptions/i18n/es/receptions.json';
import crossDockingModuleEn from '@modules/CrossDocking/i18n/en/crossDocking.json';
import crossDockingModuleEs from '@modules/CrossDocking/i18n/es/crossDocking.json';

// Importar traducciones del m?dulo OrderIncidents
import incidents_module_en from '@modules/OrderIncidents/Incidents/List/i18n/en/incidents.json';
import incidents_module_es from '@modules/OrderIncidents/Incidents/List/i18n/es/incidents.json';
import mappings_module_en from '@modules/OrderIncidents/Mappings/List/i18n/en/mappings.json';
import mappings_module_es from '@modules/OrderIncidents/Mappings/List/i18n/es/mappings.json';

// Importar traducciones del m?dulo Rates
import rates_module_en from '@modules/Rates/i18n/en/rates.json';
import rates_module_es from '@modules/Rates/i18n/es/rates.json';

// Importar traducciones del módulo AffiliatePartners
import affiliate_partners_module_en from '@modules/AffiliatePartners/i18n/en/affiliatePartners.json';
import affiliate_partners_module_es from '@modules/AffiliatePartners/i18n/es/affiliatePartners.json';

// Importar traducciones del módulo AffiliateCommissions
import affiliate_commissions_module_en from '@modules/AffiliateCommissions/i18n/en/affiliateCommissions.json';
import affiliate_commissions_module_es from '@modules/AffiliateCommissions/i18n/es/affiliateCommissions.json';

// Importar traducciones del m?dulo ExtraWorkOrders
import extra_work_orders_module_en from '@modules/ExtraWorkOrders/List/i18n/en/extraWorkOrders.json';
import extra_work_orders_module_es from '@modules/ExtraWorkOrders/List/i18n/es/extraWorkOrders.json';

// Importar traducciones del módulo Batches
import batches_module_en from '@modules/Batches/i18n/en/batches.json';
import batches_module_es from '@modules/Batches/i18n/es/batches.json';

// Importar traducciones del módulo PackingStations
import packing_stations_en from '@modules/Packaging/PackingStations/List/i18n/en/packing-stations.json';
import packing_stations_es from '@modules/Packaging/PackingStations/List/i18n/es/packing-stations.json';

// Importar traducciones del módulo Webhooks
import webhooks_module_en from '@modules/configuration/Webhooks/i18n/en/webhooks.json';
import webhooks_module_es from '@modules/configuration/Webhooks/i18n/es/webhooks.json';
import { trackingFilesEn, trackingFilesEs } from '@modules/configuration/TrackingFiles/i18n';

// Importar traducciones del módulo Integrations
import integrations_module_en from '@modules/configuration/Integrations/i18n/en/integrations.json';
import integrations_module_es from '@modules/configuration/Integrations/i18n/es/integrations.json';

// Importar traducciones del módulo WarehouseMap
import warehousemap_en from '@modules/WarehouseMap/i18n/en/warehouseMap.json';
import warehousemap_es from '@modules/WarehouseMap/i18n/es/warehouseMap.json';
// Importar traducciones del módulo ProductCategories
import product_categories_module_en from '@modules/configuration/ProductCategories/i18n/en/productCategories.json';
import product_categories_module_es from '@modules/configuration/ProductCategories/i18n/es/productCategories.json';

// Importar traducciones del módulo Logistics / SLA Couriers
import sla_alerts_en from '@modules/Logistics/SLACouriers/Alerts/i18n/en/slaAlerts.json';
import sla_alerts_es from '@modules/Logistics/SLACouriers/Alerts/i18n/es/slaAlerts.json';
import sla_claims_en from '@modules/Logistics/SLACouriers/Claims/i18n/en/slaClaims.json';
import sla_claims_es from '@modules/Logistics/SLACouriers/Claims/i18n/es/slaClaims.json';
import sla_rules_en from '@modules/Logistics/SLACouriers/Rules/i18n/en/slaRules.json';
import sla_rules_es from '@modules/Logistics/SLACouriers/Rules/i18n/es/slaRules.json';
import sla_false_delivery_en from '@modules/Logistics/SLACouriers/FalseDelivery/i18n/en/slaFalseDelivery.json';
import sla_false_delivery_es from '@modules/Logistics/SLACouriers/FalseDelivery/i18n/es/slaFalseDelivery.json';
import sla_breach_types_en from '@modules/Logistics/SLACouriers/BreachTypes/i18n/en/slaBreachTypes.json';
import sla_breach_types_es from '@modules/Logistics/SLACouriers/BreachTypes/i18n/es/slaBreachTypes.json';
import tracking_failures_en from '@modules/Logistics/SLACouriers/TrackingFailures/i18n/en/trackingFailures.json';
import tracking_failures_es from '@modules/Logistics/SLACouriers/TrackingFailures/i18n/es/trackingFailures.json';
// Importar traducciones del módulo WarehouseMaterials
import warehouse_materials_module_en from '@modules/configuration/WarehouseMaterials/i18n/en/warehouseMaterials.json';
import warehouse_materials_module_es from '@modules/configuration/WarehouseMaterials/i18n/es/warehouseMaterials.json';
// Importar traducciones del módulo AnalyticalAccounting
import analytical_accounting_en from '@modules/AnalyticalAccounting/i18n/en/analyticalAccounting.json';
import analytical_accounting_es from '@modules/AnalyticalAccounting/i18n/es/analyticalAccounting.json';
// Importar traducciones del módulo Refunds (Devoluciones)
import refunds_module_en from '@modules/Refunds/List/i18n/en/refunds.json';
import refunds_module_es from '@modules/Refunds/List/i18n/es/refunds.json';

// Importar traducciones del módulo Customer Support (Zendesk tickets)
import customer_support_module_en from '@modules/CustomerSupport/i18n/en/customerSupport.json';
import customer_support_module_es from '@modules/CustomerSupport/i18n/es/customerSupport.json';

export const i18nConfig = {
  fallbackLng: 'es',
  lng: 'es',
  supportedLngs: ['es', 'en'],
  debug: import.meta.env.MODE !== 'test',
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      ui: ui_en, // ���� Namespace para componentes UI compartidos
      auth: authEn.auth, // ���� Namespace para el m?dulo de autenticaci?n
      operatorModule: operator_module_en,
      productivity: productivityEn,
      locationsModule: locations_module_en, // Nuevo namespace para el m?dulo
      merchandiseBlocksModule: merchandise_blocks_module_en,
      stockTransfersModule: stock_transfers_module_en,
      cartsModule: carts_module_en, // Nuevo namespace para el m?dulo Carts
      stockmovementsModule: stockmovements_module_en, // Nuevo namespace para el m?dulo StockMovements
      locationmovementsModule: locationmovements_module_en, // Nuevo namespace para el m?dulo StockMovements
      packsModule: packs_module_en, // Namespace para el m?dulo de packs
      packagingModule: packaging_module_en, // Namespace para el m?dulo de packaging
      warehouseStockModule: warehouse_stock_module_en,
      packagingRecipesModule: packaging_recipes_en,
      productContainersModule: product_containers_en,
      printersModule: printers_module_en, // Namespace para el m?dulo de printers
      shopsModule: shops_module_en, // Namespace para el m?dulo de Shops
      generalModule: general_en,
      rulesModule: rules_en,
      shippingRulePresetsModule: shipping_rule_presets_en,
      preparationCalendarModule: preparation_calendar_en,
      /*bulk_actions_toolbar: bulk_actions_toolbar_en,
      pending_products: pending_products_en,
      printers: printers_en,
      stock_movements: stock_movements_en,*/
      menu: navigationEn.menu,
      general: general_en,
      merchandise: merchandise_en,
      integratedmessagingModule: integrated_messaging_en,
      rolesModule: roles_en,
      suscriptionModule: suscription_module_en, // Namespace para el m?dulo de suscripci?n
      affiliatesModule: affiliates_en,
      profileModule: profile_en,
      productsModule: products_en,
      unreferencedEntriesModule: unreferenced_entries_en,
      createEditProductsModule: create_edit_products_en,
      crmModule: crm_module_en,
      managementHoursModule: management_hours_en,
      ordersModule: orders_en,
      walletsModule: walletsModuleEn,
      withdrawalsModule: withdrawals_module_en,
      withdrawalPaymentFilesModule: withdrawalPaymentFilesModuleEn,
      bankAccountsModule: bank_accounts_module_en,
      topupsModule: topupsEn,
      accountingSyncModule: accountingSyncEn,
      invoicesOrdersModule: invoices_orders_en,
      eligibleStorageModule: eligible_storage_en,
      preInvoiceOperations: pre_invoice_operations_en,
      eligibleExtraWorkModule: eligible_extra_work_en,
      eligibleCrmManagementModule: eligible_crm_management_en,
      wholesaleBilling: wholesale_billing_en,
      shipmentCreditsModule: shipment_credits_en,
      minimumFeesModule: minimum_fees_en,
      invoicesModule: invoices_module_en,
      invoicesViewModule: invoices_view_module_en,
      preInvoicesModule: pre_invoices_en,
      viewPreInvoicesModule: view_pre_invoices_en,
      ordersShippedModule: ordersShipped_en,
      shipmentStatusTransitionsModule: shipmentStatusTransitionsEn,
      createEditOrdersModule: createEditOrders_en,
      viewOrdersModule: viewOrders_en,
      orderpreparationModule: orderpreparation_en,
      relocationsModule: relocations_en,
      relocationProcessModule: relocation_process_en,
      manifestsModule: manifests_en,
      locationordersModule: locationorders_en,
      locationordersDetailModule: locationordersDetail_en,
      pickingModule: picking_en,
      packingModule: packing_en,
      packingByCartModule: packing_by_cart_en,
      massivePackingModule: massive_packing_en,
      ordersHeldForPreparationModule: orders_held_for_preparation_en,
      pendingOrdersModule: pending_orders_en,
      homeModule: home_module_en,
      returnedModule: returned_module_en,
      receiveModule: receive_module_en,
      reusedModule: reused_module_en,
      refundReceptionsModule: refund_receptions_module_en,
      productsWithoutStockModule: products_without_stock_module_en,
      clientsModule: clients_module_en,
      createEditClientsModule: create_edit_clients_en,
      viewClientModule: view_client_en,
      coverageZonesModule: coverage_zones_en,
      shipmentStatusMappingModule: shipment_status_mapping_en,
      codPayouts: cod_payouts_en,
      codPayoutDetail: cod_payout_detail_en,
      codPayoutItems: cod_payout_items_en,
      codCourierFiles: codCourierFilesEn,
      codCourierFileDetail: codCourierFileDetailEn,
      codMismatches: codMismatchesEn,
      codReviews: codReviewsEn,
      logisticsModule: logistics_module_en,
      logisticPivotModule: logistic_pivot_module_en,
      profitabilityModule: profitability_module_en,
      trackingModule: tracking_module_en,
      marketingModule: marketing_module_en,
      inventoryModule: inventory_module_en,
      ordersWithoutWeightModule: ordersWithoutWeight_module_en,
      readyToPrepareByHourModule: readyToPrepareByHour_module_en,
      threePlExcelReportsModule: threePlExcelReports_module_en,
      warehouseExcelReportsModule: warehouseExcelReports_module_en,
      legacyDashboardModule: legacyDashboard_module_en,
      clientActivityModule: clientActivity_module_en,
      dataLoadModule: dataLoad_module_en,
      usersModule: users_module_en,
      popups: popups_en,
      notificationsModule: notifications_en,
      receptionsModule: receptions_module_en,
      crossDockingModule: crossDockingModuleEn,
      incidentsModule: incidents_module_en,
      mappingsModule: mappings_module_en,
      ratesModule: rates_module_en,
      affiliatePartnersModule: affiliate_partners_module_en,
      affiliateCommissionsModule: affiliate_commissions_module_en,
      extraWorkOrdersModule: extra_work_orders_module_en,
      batchesModule: batches_module_en,
      packingStationsModule: packing_stations_en,
      webhooksModule: webhooks_module_en,
      trackingFilesModule: trackingFilesEn,
      integrationsModule: integrations_module_en,
      warehouseMapModule: warehousemap_en,
      productCategoriesModule: product_categories_module_en,
      slaAlertsModule: sla_alerts_en,
      slaClaimsModule: sla_claims_en,
      slaRulesModule: sla_rules_en,
      slaFalseDeliveryModule: sla_false_delivery_en,
      slaBreachTypesModule: sla_breach_types_en,
      trackingFailuresModule: tracking_failures_en,
      warehouseMaterialsModule: warehouse_materials_module_en,
      analyticalAccounting: analytical_accounting_en,
      refundsModule: refunds_module_en,
      customerSupportModule: customer_support_module_en,
    },
    es: {
      ui: ui_es, // ���� Namespace para componentes UI compartidos
      auth: authEs.auth, // ���� Namespace para el m?dulo de autenticaci?n
      operatorModule: operator_module_es,
      productivity: productivityEs,
      locationsModule: locations_module_es, // Nuevo namespace para el m?dulo
      merchandiseBlocksModule: merchandise_blocks_module_es,
      stockTransfersModule: stock_transfers_module_es,
      cartsModule: carts_module_es, // Nuevo namespace para el m?dulo Carts
      stockmovementsModule: stockmovements_module_es, // Nuevo namespace para el m?dulo StockMovements
      locationmovementsModule: locationmovements_module_es, // Nuevo namespace para el m?dulo StockMovements
      packsModule: packs_module_es, // Namespace para el m?dulo de packs
      packagingModule: packaging_module_es, // Namespace para el m?dulo de packaging
      warehouseStockModule: warehouse_stock_module_es,
      packagingRecipesModule: packaging_recipes_es,
      productContainersModule: product_containers_es,
      printersModule: printers_module_es, // Namespace para el m?dulo de printers
      shopsModule: shops_module_es, // Namespace para el m?dulo de Shops
      generalModule: general_es,
      rulesModule: rules_es,
      shippingRulePresetsModule: shipping_rule_presets_es,
      preparationCalendarModule: preparation_calendar_es,
      /*bulk_actions_toolbar: bulk_actions_toolbar_es,
      pending_products: pending_products_es,
      printers: printers_es,
      stock_movements: stock_movements_es,*/
      menu: navigationEs.menu,
      general: general_es,
      merchandise: merchandise_es,
      integratedmessagingModule: integrated_messaging_es,
      rolesModule: roles_es,
      suscriptionModule: suscription_module_es, // Namespace para el m?dulo de suscripci?n
      affiliatesModule: affiliates_es,
      profileModule: profile_es,
      productsModule: products_es,
      unreferencedEntriesModule: unreferenced_entries_es,
      createEditProductsModule: create_edit_products_es,
      crmModule: crm_module_es,
      managementHoursModule: management_hours_es,
      ordersModule: orders_es,
      walletsModule: walletsModuleEs,
      withdrawalsModule: withdrawals_module_es,
      withdrawalPaymentFilesModule: withdrawalPaymentFilesModuleEs,
      bankAccountsModule: bank_accounts_module_es,
      topupsModule: topupsEs,
      accountingSyncModule: accountingSyncEs,
      invoicesOrdersModule: invoices_orders_es,
      eligibleStorageModule: eligible_storage_es,
      preInvoiceOperations: pre_invoice_operations_es,
      eligibleExtraWorkModule: eligible_extra_work_es,
      eligibleCrmManagementModule: eligible_crm_management_es,
      wholesaleBilling: wholesale_billing_es,
      shipmentCreditsModule: shipment_credits_es,
      minimumFeesModule: minimum_fees_es,
      invoicesModule: invoices_module_es,
      invoicesViewModule: invoices_view_module_es,
      preInvoicesModule: pre_invoices_es,
      viewPreInvoicesModule: view_pre_invoices_es,
      ordersShippedModule: ordersShipped_es,
      shipmentStatusTransitionsModule: shipmentStatusTransitionsEs,
      createEditOrdersModule: createEditOrders_es,
      viewOrdersModule: viewOrders_es,
      orderpreparationModule: orderpreparation_es,
      relocationsModule: relocations_es,
      relocationProcessModule: relocation_process_es,
      manifestsModule: manifests_es,
      locationordersModule: locationorders_es,
      locationordersDetailModule: locationordersDetail_es,
      pickingModule: picking_es,
      packingModule: packing_es,
      packingByCartModule: packing_by_cart_es,
      massivePackingModule: massive_packing_es,
      ordersHeldForPreparationModule: orders_held_for_preparation_es,
      pendingOrdersModule: pending_orders_es,
      homeModule: home_module_es,
      returnedModule: returned_module_es,
      receiveModule: receive_module_es,
      reusedModule: reused_module_es,
      refundReceptionsModule: refund_receptions_module_es,
      productsWithoutStockModule: products_without_stock_module_es,
      clientsModule: clients_module_es,
      createEditClientsModule: create_edit_clients_es,
      viewClientModule: view_client_es,
      coverageZonesModule: coverage_zones_es,
      shipmentStatusMappingModule: shipment_status_mapping_es,
      codPayouts: cod_payouts_es,
      codPayoutDetail: cod_payout_detail_es,
      codPayoutItems: cod_payout_items_es,
      codCourierFiles: codCourierFilesEs,
      codCourierFileDetail: codCourierFileDetailEs,
      codMismatches: codMismatchesEs,
      codReviews: codReviewsEs,
      logisticsModule: logistics_module_es,
      logisticPivotModule: logistic_pivot_module_es,
      profitabilityModule: profitability_module_es,
      trackingModule: tracking_module_es,
      marketingModule: marketing_module_es,
      inventoryModule: inventory_module_es,
      ordersWithoutWeightModule: ordersWithoutWeight_module_es,
      readyToPrepareByHourModule: readyToPrepareByHour_module_es,
      threePlExcelReportsModule: threePlExcelReports_module_es,
      warehouseExcelReportsModule: warehouseExcelReports_module_es,
      legacyDashboardModule: legacyDashboard_module_es,
      clientActivityModule: clientActivity_module_es,
      dataLoadModule: dataLoad_module_es,
      usersModule: users_module_es,
      popups: popups_es,
      notificationsModule: notifications_es,
      receptionsModule: receptions_module_es,
      crossDockingModule: crossDockingModuleEs,
      incidentsModule: incidents_module_es,
      mappingsModule: mappings_module_es,
      ratesModule: rates_module_es,
      affiliatePartnersModule: affiliate_partners_module_es,
      affiliateCommissionsModule: affiliate_commissions_module_es,
      extraWorkOrdersModule: extra_work_orders_module_es,
      batchesModule: batches_module_es,
      packingStationsModule: packing_stations_es,
      webhooksModule: webhooks_module_es,
      trackingFilesModule: trackingFilesEs,
      integrationsModule: integrations_module_es,
      warehouseMapModule: warehousemap_es,
      productCategoriesModule: product_categories_module_es,
      slaAlertsModule: sla_alerts_es,
      slaClaimsModule: sla_claims_es,
      slaRulesModule: sla_rules_es,
      slaFalseDeliveryModule: sla_false_delivery_es,
      slaBreachTypesModule: sla_breach_types_es,
      trackingFailuresModule: tracking_failures_es,
      warehouseMaterialsModule: warehouse_materials_module_es,
      analyticalAccounting: analytical_accounting_es,
      refundsModule: refunds_module_es,
      customerSupportModule: customer_support_module_es,
    },
  },
};
